import axios from "axios";
import React, { useEffect, useState } from "react";
import { ApiConnectionString } from "../../../constants/ApiConntection";
import { useAuthContext } from "../../../hooks/useAuthContext";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { Dash, FileMinus, Plus } from "react-bootstrap-icons";

export default function AccessControlModal({ cancelModal, event }) {
  const [products, setProducts] = useState([]);
  const [currentAccess, setCurrentAccess] = useState([]);
  const { user } = useAuthContext();
//styled
  const [isLoading, setIsLoading] = useState(false);

  const handleAddAccess = async (e) => {
    setIsLoading(true);
    const createProductAccess = {
      productId: e,
      eventId: event.id,
    };

    const accessResponse = await axios.post(
      `${ApiConnectionString}/api/productaccess`,
      createProductAccess,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (accessResponse.status == 200) {
      fetchData();
    }
  };

  const handleRemoveAccess = async (e) => {
    setIsLoading(true);
    const accessResponse = await axios.delete(
      `${ApiConnectionString}/api/productaccess/${e}/${event.id}`,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (accessResponse.status == 200) {
      fetchData();
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const prodResponse = await axios.get(
        `${ApiConnectionString}/api/ProductsRecurringByClub/${event.clubId}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      const currentAccessResponse = await axios.get(
        `${ApiConnectionString}/api/ProductCurrentAccess/${event.id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      setProducts(prodResponse.data);
      setCurrentAccess(currentAccessResponse.data);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      // Handle error state if needed
    }
  };

  useEffect(() => {
    fetchData();
  }, [event.clubId, event.id, user.token]);

  // Remove products with IDs that match any ID in currentAccess
  const filteredProducts = products.filter((product) => {
    return (
      !currentAccess.some((access) => access.id === product.id) &&
      !product.totalAccess
    );
  });

  if (isLoading) {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <LoadingSpinner />
          <div className="send-modal-footer"></div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="send-modal-overlay">
        <div className="send-modal">
          <div className="send-modal-overlay">
            <div className="send-modal">
              <div className="blueBanner">
                <p className="fw-bold m-2 p-2 fontSize20">
                  Manage Subscription Access
                </p>
              </div>
              <button
                type="button"
                className="close-button"
                onClick={cancelModal}
                aria-label="Close"
              >
                &times;
              </button>

              <table className="">
                <tbody>
                  <tr>
                    <th className="red-text">Name</th>
                    <td>{event.name}</td>
                  </tr>

                  <tr>
                    <th className="red-text">Day</th>
                    <td>{event.day}</td>
                  </tr>
                  <tr>
                    <th className="red-text">Time</th>
                    <td>
                      {event.timeIn} - {event.timeOut}
                    </td>
                  </tr>

                  {event.oneOffDate && (
                    <tr className="red-text">
                      <th>Date</th>
                      <td>{event.oneOffDate}</td>
                    </tr>
                  )}
                </tbody>
              </table>

              <p>
                To manage access, select a subscription from the 'Available'
                list to grant access to this class. To revoke access, select a
                subscription from the 'Current Access' list.
              </p>
              <p>
                Subscriptions with 'Total Access' are not listed here, as they
                automatically have access to all classes.
              </p>
              <div className="lightBlueBanner">
                <p className="fw-bold p-2">Current Access</p>
              </div>

              {currentAccess.length == 0 && (
                <p>No subscriptions currently have access to this class</p>
              )}
              {currentAccess.map((product) => (
                <div key={product.id}>
                  {/* Render product details */}
                  <p className="fw-bold">
                    {product.name}{" "}
               
                    <button
                     onClick={() => {
                      handleRemoveAccess(product.id);
                    }}
                      className="profile-blue-button mb-2"
                    >
                      <Dash className="profile-social-icon" />{" "}
                      <a className="fw-bold mx-2 mt-1">Remove</a>
                    </button>
                  </p>
                </div>
              ))}
              <div className="lightBlueBanner">
                <p className="fw-bold p-2">Available</p>
              </div>

              {filteredProducts.length == 0 && (
                <p>No available subscriptions to add.</p>
              )}
              {filteredProducts.map((product) => (
                <div key={product.id} className="d-flex">
                  {/* Render product details */}
                  <p className="fw-bold">
                    {product.name}{" "}
                    <button
                      onClick={() => {
                        handleAddAccess(product.id);
                      }}
                      className="profile-blue-button mb-2"
                    >
                      <Plus className="profile-social-icon" />{" "}
                      <a className="fw-bold mx-2 mt-1">Add</a>
                    </button>
                  </p>
                </div>
              ))}
              <div className="send-modal-footer">
              <button
                  onClick={cancelModal}
                  className="pointer cancelButton fw-bold mx-2 px-3"
                >
                  Close
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
